import { render } from "./CurrencySwitcher.vue?vue&type=template&id=35d5b1bf"
import script from "./CurrencySwitcher.vue?vue&type=script&lang=js"
export * from "./CurrencySwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__